export const FETCH_PROFILE = 'FETCH_PROFILE';

export const profileAction = (profile) => ({
  type: FETCH_PROFILE,
  payload: profile
});

